import { IFileMetadata } from './file-metadata.interface';
import { FormalControlStatus } from './formal-control-status.enum';
import { InspectorStatusEnum } from './inspector-status.enum';

export const SUPPLIER_PROJECT_EDITABLE_METADATA_FIELDS = [
  'KKS',
  'DocumentClass',
  'DocumentClassContent',
] as const;

export const DAISY_KKS_SEPARATOR = '#';
export const OBJECT_ID_KKS_SEPARATOR = '#';

export const KKS_METADATA_FIELD = 'KKS';

export const OBJECT_ID_METADATA_FIELD = 'ObjectID';

export const CREATED_BY_METADATA_FIELD = 'CreatedBy';

export const DOCUMENT_CLASS_METADATA_FIELD = 'DocumentClass';

export const DOCUMENT_CLASS_CONTENT_METADATA_FIELD = 'DocumentClassContent';

export const DEFAULT_CONFIDENTIAL_CLASS = 'C3';

export const DEFAULT_RESPONSIBLE_AREA = 'Instandhaltung';

export const DEFAULT_NEW_DOC_STATUS = 'neu';
export const DEFAULT_TRANSFERED_DOC_STATUS = 'freigegeben';

export const TITLE_METADATA_FIELD: keyof IFileMetadata = 'Title';

export const ORIGNINAL_FILE_NAME_METADATA_FIELD: keyof IFileMetadata =
  'OriginalFilename';

export const DOC_LANGUAGE_METADATA_FIELD: keyof IFileMetadata = 'DocLanguage';

export const CREATE_DATE_METADATA_FIELD: keyof IFileMetadata = 'CreateDate';

export const RELEASE_DATE_METADATA_FIELD: keyof IFileMetadata = 'ReleaseDate';

export const positiveFormalControlStatuses: FormalControlStatus[] = [
  FormalControlStatus.ACCEPTED,
  FormalControlStatus.ACCEPTED_WITH_REMARKS,
];

export const actionableFormalControlStatuses: FormalControlStatus[] = [
  FormalControlStatus.ACCEPTED_WITH_REMARKS,
  FormalControlStatus.REJECTED,
];

export const WAITING_FORMAL_CONTROL_STATUSES: FormalControlStatus[] = [
  FormalControlStatus.WAITING,
];

export const negativeFormalControlStatuses: FormalControlStatus[] = [
  FormalControlStatus.REJECTED,
];

export const waitingInspectorStatuses: InspectorStatusEnum[] = [
  InspectorStatusEnum.waiting,
  InspectorStatusEnum.waitingForFormalControl,
];

export const POSITIVE_INSPECTION_STATUSES: InspectorStatusEnum[] = [
  InspectorStatusEnum.accepted,
  InspectorStatusEnum.acceptedWithRemarks,
];

export const INSPECTION_DONE_STATUSES: InspectorStatusEnum[] = [
  InspectorStatusEnum.accepted,
  InspectorStatusEnum.acceptedWithRemarks,
  InspectorStatusEnum.rejected,
];

export const SUPPLIER_DOCUMENT_ID_PARAM = 'supplierDocumentId';
